import * as React from "react";
import { useRef } from "react";
import { useMenu } from "../Menu/useMenu";
import { useSearch } from "../Search/useSearch";
import { getMobileDevice, isBrowser } from "../utils";

export function BlackLayer() {
  if (!isBrowser()) return null;
  const { closeMenu, isOpen: isMenuOpen } = useMenu();
  const { isSearchOpen, closeSearch } = useSearch();
  const elRef = useRef<HTMLDivElement>();
  const isOpen = isMenuOpen || isSearchOpen;
  const { isAndroid, isIPhone } = getMobileDevice(navigator);

  return (
    <div
      ref={elRef}
      data-visible={isOpen}
      data-testid="elements--menu--black-layer"
      className={`elm-bg-opacity-0 elm-fixed elm-z-10 elm-top-0 elm-left-0 elm-bottom-0 elm-right-0 elm-h-screen elm-w-full elm-bg-black elm-transition-all elm-duration-700 ${
        isOpen && !isAndroid && !isIPhone
          ? "elm-pointer-events-auto elm-bg-opacity-70"
          : "elm-pointer-events-none elm-bg-opacity-0"
      }`}
      onClick={isMenuOpen ? closeMenu : closeSearch}
    ></div>
  );
}
